import styled from 'styled-components';
import { Menu } from 'semantic-ui-react';
const Submenu = styled(Menu.Menu)`
  position: absolute;
  bottom: 40px;
  width: 100%;
`;

export default Submenu;
